import {JSX, ReactNode} from "react";

import classNames from "classnames";

import "@/shared/ui/layout/styles/container-base.scss";

interface Props {
    children: ReactNode;
    className?: string;
}
export function ContainerBase({children, className}: Props): JSX.Element {
    return <div className={classNames("container_base", className)}>{children}</div>;
}
